import React, { Component } from 'react';
import request from "superagent";
import tree from "../../state";

class Ankle extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showSuccess: false
		}
		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit(e) {
		e.preventDefault();
		let formData = {
			firstName: e.target.firstName.value,
			zipPostal: e.target.zipPostal.value,
			emailAddress: e.target.emailAddress.value,
			elqFormName: e.target.elqFormName.value,
			elqSiteId: e.target.elqSiteId.value,
			elqCampaignId: e.target.elqCampaignId.value
		};

		let response = this.eloquaSubmit(formData);
		this.setState({ showSuccess: true });
	}

	encodeFormData = (data) => {
		return Object.keys(data)
			.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
			.join('&');
	}

	eloquaSubmit(formData) {
		return fetch(
			`https://s351095147.t.eloqua.com/e/f2`,
			{
				method: 'POST',
				mode: 'no-cors',
				body: this.encodeFormData(formData),
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}
		).then(function (response) {
			return response;
		});
	}

	render() {
		const { showSuccess } = this.state;
		const { formConfig } = this.props;
			return (
				<div id="sign-up">
					<div className="row ankle pt-4">
						<div className="text-center">
							<img
								className="icon"
								src={require('../../resources/img/icons/newsletter.png')}
								alt=""
							/>
						</div>
						{!showSuccess &&
							<div>
								<div className="text-center">
									<h2 className="h3 mb-2 font-weight-bold">{formConfig.title}</h2>
									<p className="small" dangerouslySetInnerHTML={{ __html: formConfig.subtitle }} />
								</div>
								<div className="col eloquaForm">
									<form onSubmit={e => this.onSubmit(e)}>
										<input value={formConfig.elqFormName} type="hidden" name="elqFormName" />
										<input value="351095147" type="hidden" name="elqSiteId" />
										<input name="elqCampaignId" type="hidden" value="ss" />
										<div className="form-group col mx-auto">
											<div className="col mb-1 mb-lg-0 md-3">
												<input type="text" name="firstName" id="fe1366" required="true" placeholder="FIRST NAME" />
											</div>
											<div className="col mb-1 mb-lg-0 md-2">
												<input type="text" name="zipPostal" maxLength="5" pattern="[0-9]*" id="fe1367" required="true" placeholder="ZIP CODE" />
											</div>
											<div className="col mb-1 mb-lg-0 md-5 pr-lg-0">
												<input type="email" name="emailAddress" id="fe1368" required="true" placeholder="YOU@EMAIL.COM" />

											</div>
											<div className="col mb-1 mb-lg-0 md-2 ml-0 pl-lg-0">
												<button type="submit" className="btn btn-primary btn-block" id="fe1369">Subscribe</button>
											</div>
										</div>
										<div className="form-group col mx-auto">
											<div className="col text-center sm">
												<small className="disclaimer">{formConfig.disclaimer}</small>
											</div>
										</div>
									</form>
								</div>
							</div>
						}
						{showSuccess &&
							<div>
								<h2 className="h3 font-weight-bold text-center">Success!</h2>
								<div className="col text-center mb-4">
									<p dangerouslySetInnerHTML={{ __html: formConfig.successMessage }} />
								</div>
							</div>
						}
					</div>
				</div>
			);
	};
}

export default Ankle;


// WEBPACK FOOTER //
// ./src/pages/components/Ankle.js